import { createAction, props } from "@ngrx/store";
import { IQueryResult } from "@pmis3/data-access";
import { IOrganization, IOrganizationType } from "../model/organization";

export enum OrganizationActionTypes {
    LoadOrganizations = "[VesselVisit Page] Load Organizations",
    LoadOrganizationsSuccess = "[VesselVisit Page] Load Organizations Success",
    LoadOrganizationsFail = "[VesselVisit Page] Load Organizations Fail",
    LoadOrganizationTypes = "[VesselVisit Page] Load Organizations Types",
}

export const LoadOrganizations = createAction(
  OrganizationActionTypes.LoadOrganizations
)

export const LoadOrganizationsSuccess = createAction(
  OrganizationActionTypes.LoadOrganizationsSuccess,
  props<{result: IOrganization[] | undefined }>()
);

export const LoadOrganizationsFail = createAction(
  OrganizationActionTypes.LoadOrganizationsFail,
  props<{ error: string }>()
);

export const LoadOrganizationTypes = createAction(
  OrganizationActionTypes.LoadOrganizationTypes,
  props<{ organizationTypes: IOrganizationType[] }>()
)